<template>
	<div>
		<b-row class="align-items-center">
			<b-col cols="6">
				<b-button variant="link" @click="emitEvent('go-back-to-chat-main')" class="px-0">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
						<path fill="currentColor" d="m14 18-6-6 6-6 1.4 1.4-4.6 4.6 4.6 4.6L14 18Z" />
					</svg>
					Back
				</b-button>
			</b-col>
		</b-row>
		<b-row>
			<b-col cols="12">
				<h3 class="font-weight-500">Create Group</h3>
			</b-col>
		</b-row>
		<b-form role="form" @submit.prevent="createGroup">
			<b-row>
				<b-col cols="12" v-if="!isCurrentUserExternal">
						<b-form-group label="Group Type">
								<b-form-radio-group
										v-model="new_group.type"
										:options="typeOptions"
								></b-form-radio-group>
						</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group label="Group Name">
						<b-form-input v-model="new_group.name" type="text" required></b-form-input>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<edit-group-member :currentGroup="detailGroup" :groupType="new_group.type" :initMember="initMessageMember" @update="setSelectedParticipant($event)"></edit-group-member>
					<span class="text-danger" v-if="auto_add_participant"><i>You will create a public group, All user which have access to this profile data will auto add to this group and able see all chat message. <br/> If found user not auto add please add after group created on edit group feature</i></span>
				</b-col>
				<b-col cols="12" class="text-center">
					<b-button type="submit" variant="primary" class="py-2 px-5 mt-5">Create Group</b-button>
				</b-col>
			</b-row>
		</b-form>
	</div>
</template>
<script>
import { Select, Option } from 'element-ui'
import chatEventBus from '@/assets/js/EventBus/chatEventBus.js'
import { mapState, mapActions } from 'pinia'
import { useMessagingStore } from '@/stores/messagingStore'
import { swal } from '@/assets/js/httpImports.js'
import EditGroupMember from '@/views/Messaging/Chats/EditGroupMember'

export default {
	props: {
		showCreatNewGroup: Boolean,
		showMainPage: Boolean,
		showChatRooms: Boolean,
	},
	components: {
		EditGroupMember,
		[Option.name]: Option,
		[Select.name]: Select,
	},
	data() {
		return {
			initMessageMember:false,
			detailGroup: null,
			selectedIds: [],
			newIds: [],
			removeIds: [],
			selectedAdminIds: [],
			newAdminIds: [],
			removeAdminIds: [],
			new_group: {
				name: _gAuth.isAppVps()? 'Public Chat' : '',
				type: 'internal',
				group_channel_type: 'PUBLIC'
			},
			typeOptions: [
				{ text: 'Internal', value: 'internal' },
				{ text: 'External', value: 'external' },
			]
		}
	},
	watch: {
		message_profile: {
			handler(newVal) {
				this.resetData()
			},
			immediate: true
		},
		showCreatNewGroup: {
			handler(newVal) {
				this.initMessageMember = newVal
			},
			immediate: true
		},
		
	},
	computed: {
		...mapState(useMessagingStore, ['selected_group', 'available_user_list', 'message_profile']),
		// is_external_chat() {
		// 	return _gAuth.isAppSas() && !_gHlp.isEmpty(this.message_profile) && this.message_profile.type == 'proposal';
		// }
		auto_add_participant(){
			return _gHlp.getValue(this.message_profile,'auto_add_participant', false)
		},
		isCurrentUserExternal(){
			return _gAuth.activeUser('account_info.user_settings.is_external_staff',false) && _gAuth.isAppSas();
		}
	},
	methods: {
		...mapActions(useMessagingStore, ['createGroupMessage', 'getNewBundleKey']),
		emitEvent(eventName) {
			chatEventBus.$emit(eventName)
			if (eventName === 'go-back-to-chat-main') {
				this.resetData()
			}
		},
		async createGroup() {
			const postData = {
				group_name: this.new_group.name,
				group_type: (this.isCurrentUserExternal) ? 'external' : this.new_group.type, //default: 'internal',
				group_channel_type: 'PUBLIC',
				group_bundle_key: this.getNewBundleKey(),
				group_participants: []
			}
			// Selected IDs and get all its objects
			const activeUser = _gAuth.activeUser()
			if (!_gHlp.isEmpty(activeUser)) {
				postData.group_participants.push({
					participant_user_id: activeUser.id,
					participant_username: activeUser.name,
					participant_fullname: activeUser.name,
					participant_photo_profile: null,
					gmp_is_admin: 1
				});
			}

			let adminUserIds = this.selectedAdminIds;
			this.selectedIds.forEach(selectedId => {
				const selectedUser = this.available_user_list.find(user => user.id == selectedId)
				if (selectedUser) {
					if (selectedUser.id != activeUser.id) {
						let isAdmin = adminUserIds.includes(selectedUser.id) ? 1 : 0;
						postData.group_participants.push({
							participant_user_id: selectedUser.id,
							participant_username: selectedUser.name,
							participant_fullname: selectedUser.name,
							participant_photo_profile: null,
							gmp_is_admin: isAdmin,
							participant_application_code: selectedUser.application_code
						});
					}
				}
			});
			let status = await this.createGroupMessage(postData)
			if (status) {
				this.resetData();
				this.emitEvent('show-chats-room', this.selected_group)
			}
		},
		setSelectedParticipant(params) {
			this.selectedIds = params.listSelectedIds
			this.newIds = params.listNewIds
			this.removeIds = params.listRemoveIds

			this.selectedAdminIds = params.listSelectedAdminIds
			this.newAdminIds = params.listNewAdminIds
			this.removeAdminIds = params.listRemoveAdminIds
		},
		resetData() {
			this.detailGroup = null

			this.selectedIds = []
			this.newIds = []
			this.removeIds = []

			this.selectedAdminIds = []
			this.newAdminIds = []
			this.removeAdminIds = []

			this.new_group = {
				name: _gAuth.isAppVps()? 'Public Chat' : '',
				type: (this.isCurrentUserExternal) ? 'external' : 'internal',
				group_channel_type: 'PUBLIC'
			}
		},
	},
}
</script>